import React, { useCallback, useEffect, useState } from 'react'
import { queryOptions, useQuery } from '@tanstack/react-query'
import { queryClient as qc } from 'keys'
import { getScoreRatingSemestersFetch } from 'store/middlewares/rating.crud'
import { getMethodsFetch } from 'store/middlewares/affiliation.crud'
import { getAssessmentSummaryByTestTakerFetch } from 'store/middlewares/assessment.crud'
import { Backdrop, CircularProgress } from '@mui/material'
import Normalizer from './Normalizer'

const NormalizerPage = () => {
    const [assessmentFilters, setAssessmentFilters] = useState({})
    const [scoreRatingOptions, setScoreRatingOptions] = useState([])
    const [applyDataConfirmOpen, setApplyDataConfirmOpen] = useState(false)
    const [activeScoreRatingIndex, setActiveScoreRatingIndex] = useState(null)
    const [activeScoreItemStatus, setActiveScoreItemStatus] = useState("")
    const [stats, setStats] = useState([])
    const [checkType, setCheckType] = useState()
    const [loadingData, setLoadingData] = useState(false)
    const [openBackDrop, setOpenBackDrop] = useState(false);

    const methodOptions = queryOptions({
        queryKey: [qc.methods],
        queryFn: async () => {
            const { data } = await getMethodsFetch()
            const goMethodIndex = data.findIndex(method => method.id == 2)
            setAssessmentFilters({ ...assessmentFilters, methods: [data[goMethodIndex]] })
            return data
        },
        refetchOnWindowFocus: false,
        enabled: !assessmentFilters.methods
    })

    const scoreRatingSemesterOptions = queryOptions({
        queryKey: [qc.scoreRatingSemesters],
        queryFn: async () => {
            const { data } = await getScoreRatingSemestersFetch({ assessmentFilters })
            setScoreRatingOptions(new Array(data.length).fill({
                showChildren: false,
                edit: false,
                showStartBar: false,
                showEndBar: false,
                showTable: false
            }))
            setStats(new Array(data.length))
            return data
        },
        enabled: false
    })
    const assessmentCount = useQuery({
        queryKey: [qc.assessmentCount, assessmentFilters],
        queryFn: async () => {
            const { data } = await getAssessmentSummaryByTestTakerFetch({ assessmentFilters })
            return data
        }
    })

    const scoreRatingSemesters = useQuery(scoreRatingSemesterOptions)
    const methods = useQuery(methodOptions)

    const commonState = {
        scoreRatingSemesters,
        assessmentFilters, setAssessmentFilters,
        scoreRatingOptions, setScoreRatingOptions,
        activeScoreRatingIndex, setActiveScoreRatingIndex,
        applyDataConfirmOpen, setApplyDataConfirmOpen,
        stats, setStats,
        openBackDrop, setOpenBackDrop,
        activeScoreItemStatus, setActiveScoreItemStatus,
        checkType, setCheckType,
        loadingData, setLoadingData,
        methods: methods.data,
        assessmentCount
    }

    return (
        <NormalizerContext.Provider value={commonState}>
            <Normalizer />
            {/* <Backdrop open={openBackDrop}><CircularProgress color="inherit" /></Backdrop> */}
        </NormalizerContext.Provider>
    )
}

export const NormalizerContext = React.createContext()
export default NormalizerPage